import { LeadSelfOnboardingTransfer } from "src/models/selfOnboardingClientsModels";
import { callApi, callLeadTransfer } from "./callApi";

export const leadSelfOnboardingTransfer = ({
  transferId,
  salesPartnerUuid,
}: {
  transferId: string;
  salesPartnerUuid: string;
}): Promise<LeadSelfOnboardingTransfer> => {
  return callLeadTransfer({
    path: `/api/v1/lead/site-self-onboarding/transfer/${salesPartnerUuid}?transfer_id=${transferId}`,
  });
};

export const hemProviders = (
  transferId: string,
): Promise<{
  hemProviders: {
    logicalId: string;
    displayName: string;
  }[];
}> => {
  return callApi({
    path: `/api/v1/lead/site-self-onboarding/hem-providers`,
    transferId,
  });
};

export const setHemProvider = (
  transferId: string,
  logicalId: string,
): Promise<{
  msgId: string;
}> => {
  return callApi({
    path: `/api/v1/lead/site-self-onboarding/hem-providers?hem_provider_logical_id=${logicalId}`,
    method: "POST",
    transferId,
  });
};

interface AuthenticationUrlProps {
  transferId: string;
}

export const selfOnboardingAuthenticationUrl = ({
  transferId,
}: AuthenticationUrlProps): Promise<{
  attachedState: string;
  authenticationUrl: string;
}> => {
  return callApi({
    transferId,
    method: "POST",
    path: `/api/v1/lead/site-self-onboarding/authentication-url`,
  });
};

interface AuthenticationCallbackProps {
  searchParams: string;
  transferId: string;
}

export const authenticationCallback = ({
  searchParams,
  transferId,
}: AuthenticationCallbackProps): Promise<{
  msgId: string;
}> => {
  return callApi({
    transferId,
    method: "POST",
    path: `/api/v1/lead/site-self-onboarding/authentication-callback${searchParams}`,
  });
};
